import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm, Controller } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import { CircularProgress } from "@mui/material";
import permissions from "permissions";
import { KanbanAPI } from "api/KanbanAPI";
import { ProductionLineAPI } from "api/ProductionLineAPI";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from '@mui/material/TextField';

export default function CtrTable(props) {

  const [ctr, setCTR] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, control, setValue, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props

  const [lineas, setLineas] = useState([]);
  const [selectedLineas, setSelectedLineas] = useState([]);

  //Modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderCtr = useMemo(() => {
    setOpen(false);
    let rows = [];
    const columns = [
      { Header: "Fecha", accessor: "fecha", align: "right" },
      { Header: "Producto", accessor: "producto", align: "right" },
      { Header: "Valor Unitario", accessor: "valor_unitario", align: "right" },
      { Header: "Frecuencia", accessor: "frecuencia", align: "right" },
      { Header: "DS", accessor: "ds", align: "right" },
      { Header: "Promedio", accessor: "promedio", align: "right" },
      { Header: "Manejo", accessor: "manejo", align: "left" },
      { Header: "Xc", accessor: "xc", align: "right" },
      { Header: "DSxc", accessor: "dsxc", align: "right" },
      { Header: "NSc", accessor: "nsc", align: "right" },
      { Header: "XLTp", accessor: "xltp", align: "right" },
      { Header: "XLTx", accessor: "xltx", align: "right" },
      { Header: "OTCc", accessor: "otcc", align: "right" },
      { Header: "SS", accessor: "ss", align: "right" },
      { Header: "T", accessor: "t", align: "right" },
      { Header: "K", accessor: "k", align: "right" },
      { Header: "INV", accessor: "inv", align: "right" },
      { Header: "MRP", accessor: "mrp", align: "right" },
      { Header: "OC", accessor: "oc", align: "right" },
      { Header: "QP", accessor: "qp", align: "right" },
      { Header: "A OC Unitario", accessor: "aoc", align: "right" },
      { Header: "LT", accessor: "lt", align: "right" },
      { Header: "LS", accessor: "ls", align: "right" },
      { Header: "Detalle", accessor: "descripcion", align: "left" },
      { Header: "Grupo", accessor: "grupo", align: "left" },
      { Header: "Abrir OC", accessor: "abrir_oc", align: "right" },
      { Header: "$ Inventario", accessor: "$_inventario", align: "right" },
      { Header: "$ X", accessor: "$_x", align: "right" },
      { Header: "$ SS", accessor: "$_ss", align: "right" },
      { Header: "$ T", accessor: "$_t", align: "right" },
      { Header: "$ K", accessor: "$_k", align: "right" },
      { Header: "$ Promedio Unitario", accessor: "promedio_unitario", align: "right" },
    ];

    ctr?.map((element) => {
      rows = [...rows,
      {
        fecha: element.fecha,
        producto: element.codigo,
        valor_unitario: currencyformatter.format(Number(element.valor_unitario).toFixed(2)),
        frecuencia: numberFormater.format(Number(element.frecuencia).toFixed(2)),
        ds: numberFormater.format(Number(element.ds).toFixed(2)),
        promedio: numberFormater.format(Number(element.promedio).toFixed(2)),
        manejo: element.manejo,
        xc: numberFormater.format(Number(element.xc).toFixed(2)),
        dsxc: numberFormater.format(Number(element.dsxc).toFixed(2)),
        nsc: numberFormater.format(Number(element.nsc).toFixed(2)),
        xltp: numberFormater.format(Number(element.xltp).toFixed(2)),
        xltx: numberFormater.format(Number(element.xltx).toFixed(2)),
        otcc: numberFormater.format(Number(element.otcc).toFixed(2)),
        ss: numberFormater.format(Number(element.ss).toFixed(2)),
        t: numberFormater.format(Number(element.t).toFixed(2)),
        k: numberFormater.format(Number(element.k).toFixed(2)),
        inv: numberFormater.format(Number(element.inv).toFixed(2)),
        mrp: numberFormater.format(Number(element.mrp).toFixed(2)),
        oc: numberFormater.format(Number(element.oc).toFixed(2)),
        qp: numberFormater.format(Number(element.qp).toFixed(2)),
        aoc: numberFormater.format(Number(element.aoc).toFixed(2)),
        lt: numberFormater.format(Number(element.lt).toFixed(2)),
        ls: numberFormater.format(Number(element.ls).toFixed(2)),
        descripcion: element.descripcion,
        grupo: element.grupo,
        abrir_oc: numberFormater.format(Number(element.abrir_oc).toFixed(2)),
        $_inventario: currencyformatter.format(Number(element.$_inventario).toFixed(2)),
        $_x: currencyformatter.format(Number(element.$_x).toFixed(2)),
        $_ss: currencyformatter.format(Number(element.$_ss).toFixed(2)),
        $_t: currencyformatter.format(Number(element.$_t).toFixed(2)),
        $_k: currencyformatter.format(Number(element.$_k).toFixed(2)),
        promedio_unitario: numberFormater.format(Number(element.promedio_unitario).toFixed(2)),
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [ctr])

  const [progress, setProgress] = useState(0);
  const [checkingProgress, setCheckingProgress] = useState(false);

  const startProgressWatcher = () => {
    setCheckingProgress(true);

    const interval = setInterval(() => {
      KanbanAPI.getCtrProgress()   // ← endpoint GET que devuelve { percent }
        .then(res => {
          setProgress(res.percent);

          // Si llegó al 100, dejar de consultar
          if (res.percent >= 100) {
            setCheckingProgress(false);
            clearInterval(interval);
          }
        })
        .catch(() => {
          // Si falla es porque terminó o expiró el lock
          clearInterval(interval);
          setCheckingProgress(false);
        });
    }, 30000); // cada 30 segundos
  };


  const calculateCtr = (data) => {
    const selectedIds = data.linea;

    setLoading(dispatch, true)
    startProgressWatcher();

    return KanbanAPI.calculateCtr( {selectedIds} )
      .then(response => {
        handleAlert(response.ctr.meta.message, response.status)
        setCTR(response.ctr.data)
        
      }).catch(error => {
        if (error.response) {
          const { status, data } = error.response;

          // Si el backend devolvió 423 Locked
          if (status === 423) {
            handleAlert(
              data.message || "CTR en ejecución. Intenta más tarde.",
              "warning"
            );
            return;
          }

          // Otros errores controlados
          handleAlert(
            data.message || "Error ejecutando CTR",
            data.status || "error"
          );
        } else {
          // Errores de red / Axios
          handleAlert("Error desconocido al ejecutar CTR", "error");
        }
      }).finally(() => {
        setLoading(dispatch, false);
        // terminar polling
        setCheckingProgress(false);
      });
  }

  const getCtr = () => {
    setLoading(dispatch, true)
    return KanbanAPI.index(true)
      .then(response => {
        setCTR(response.ctr)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  const getProductionLine = () => {
    return ProductionLineAPI.index(true)
      .then(response => {
        setLineas(response.productionLines);

        if (response.productionLines.length > 0) {
          setSelectedLineas(response.productionLines);
          setValue("linea", response.productionLines.map(l => l.linea));
        }
      })
      .catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  useEffect(() => {
    window.history.replaceState({}, document.title)

    const abortController = new AbortController();
    const signal = abortController.signal

    setLoading(dispatch, true)
    getCtr(signal)
    // getProductionLine(signal)

    // setLineas( [
    //   { id: 'L1', title: 'L1 Motos' },
    //   { id: '2', title: 'L2 Buses' },
    //   { id: '3', title: 'L3 Blanca' },
    //   { id: '4', title: 'L4 Multiplex' }]
    // )

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    getCtr();
  }, [props.reloadTrigger]);

  return (
    <MDBox>
      <Dialog open={open} onClose={handleClose} >
        <MDBox component="form" role="form" onSubmit={handleSubmit(calculateCtr)}>
          <DialogTitle>Ejecución del CTR por todas las líneas</DialogTitle>
          <DialogContent>
            <Controller
              name="linea"
              control={control}
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  multiple
                  value={selectedLineas}
                  options={lineas}
                  getOptionLabel={(linea) => linea.nombre_linea}
                  readOnly
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Líneas"
                      placeholder="Líneas"
                    />
                  )}
                  // onChange={(event, items) => {
                  //   setSelectedLineas(items);
                  //   onChange(items.map(item => item.linea)); // Mapear a los IDs seleccionados
                  // }}
                />
              )}
            />
          </DialogContent>
          <DialogActions>
            <MDButton onClick={handleClose}>Cancelar</MDButton>
            <MDButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? <CircularProgress size={18} color="info" /> : 'Calcular CTR'}
            </MDButton>
          </DialogActions>
        </MDBox>
      </Dialog>
      {/* <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form">
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton variant="gradient" color="info" disabled={isSubmitting} onClick={handleOpen}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Calcular CTR'}
          </MDButton>
        )}
      </MDBox> */}
      <MDBox>
        {/* barra de progreso del CTR */}
        {checkingProgress && (
          <MDBox sx={{ p: 2 }}>
            <strong>Calculando CTR...</strong> {progress}%
          </MDBox>
        )}
        {loading ? <TableSkeleton></TableSkeleton> : renderCtr}
      </MDBox>
    </MDBox>
    
  )
}